import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      d: "M12.707 22.88a1 1 0 0 1-1.414 0L1.119 12.708a1 1 0 0 1 0-1.414L11.293 1.119a1 1 0 0 1 1.414 0l10.174 10.174a1 1 0 0 1 0 1.414L12.707 22.881Z"
    }, null, -1)
  ]));
}
const basicShapeDiamond = { render };
export {
  basicShapeDiamond as default,
  render
};
//# sourceMappingURL=basic-shape-diamond.svg.js.map
